import isEqual from 'lodash/isEqual';

export function hideMarker(marker: google.maps.Marker) {
  marker.setVisible(false);
}

export function blurMarker(marker: google.maps.Marker) {
  marker.setOpacity(0.2);
  marker.setZIndex(1);
  marker.setVisible(true);
}

export function focusMarker(marker: google.maps.Marker) {
  marker.setOpacity(1);
  marker.setZIndex(10);
  marker.setVisible(true);
}

export const changeMarkersAccordingToFilter = async ({
  markers,
  filteredDataIds,
  activeStation,
  cityStations,
}: {
  markers: IMarkersObject;
  filteredDataIds;
  activeStation;
  cityStations;
}) => {
  Object.entries(markers).forEach(([key, marker]) => {
    if (!filteredDataIds.includes(key)) {
      hideMarker(marker);
    } else {
      if (key === activeStation) {
        focusMarker(marker);
      }
      if (cityStations.includes(key)) {
        focusMarker(marker);
      } else if (activeStation || cityStations?.length) {
        blurMarker(marker);
      }
      focusMarker(marker);
    }
  });
};
export type IMarkersObject = {[key: string]: google.maps.Marker};

export const changeMarkersAccordingToSelectedStationAndCity = async ({
  activeStation,
  lastActiveStation,
  lastActiveCitystations,
  markers,
  cityStations,
  filteredDataIds,
}: {
  markers: IMarkersObject;
  filteredDataIds;
  activeStation;
  cityStations;
  lastActiveStation;
  lastActiveCitystations;
}) => {
  if (activeStation !== lastActiveStation || !isEqual(cityStations, lastActiveCitystations)) {
    if (activeStation) {
      Object.entries(markers)
        .filter(([key]) => key !== activeStation)
        .forEach(([key, marker]) => {
          !filteredDataIds
            ? blurMarker(marker)
            : filteredDataIds.includes(key)
            ? blurMarker(marker)
            : hideMarker(marker);
        });
      markers[activeStation as string] && focusMarker(markers[activeStation as string]);
    } else if (cityStations?.length) {
      Object.entries(markers).forEach(([key, marker]) => {
        if (cityStations.includes(key)) {
          focusMarker(marker);
        } else {
          !filteredDataIds
            ? blurMarker(marker)
            : filteredDataIds.includes(key)
            ? blurMarker(marker)
            : hideMarker(marker);
        }
      });
    } else {
      Object.entries(markers).forEach(([key, marker]) => {
        !filteredDataIds
          ? focusMarker(marker)
          : filteredDataIds.includes(key)
          ? focusMarker(marker)
          : hideMarker(marker);
      });
    }
  }
};
